<template>
    <div v-show="isBlockVisible">
        <div v-if="havePermission"
            class="form-group col-12 alert alert alert-primary dark alert-primary middle d-flex align-items-center justify-content-between m-0"
            :class="{ 'TitleBg': IsHidenBody }" style="margin-bottom: 0px !important;z-index: 8;">
            <div class="TitleBgFlex">
                <span :class="{ 'TitleBg_Title': IsHidenBody }">
                    {{ TitleText ?? $t("lbl_EMPBE_DesignatedAdvertiserOnly") }} <i class="fa fa-lock"></i>
                </span>
                <div class="TitleBg_Btn">
                    <b-button v-if="IsHidenBody" class="Title_btSyles_More" v-b-toggle="PopupId ? PopupId : PopupUid"
                        variant="outline-primary" ref="btn_visitorPermissionPopup"
                        v-bind:t_label="'EMPBE_VisitorPermission_' + currentRouteName + '_btnLearnMore'">
                         <i class="fa fa-eye"></i>
                        <span>{{ MoreText ?? $t("lbl_EMPBE_LearnMore") }}</span>
                    </b-button>
                    <b-button class="Title_btSyles_ConBuyer" variant="primary" v-if="CellUrl && IsHidenBody"
                        @click="GotoCellUrl" v-bind:t_label="'EMPBE_VisitorPermission_' + currentRouteName + '_Url'">
                        <img :src="cdnURL + 'cell.svg'">
                        <span>{{ $t("lbl_EMPBE_visitorPermissionPopup_ConBuyerPhone") }}</span>
                    </b-button>
                </div>
            </div>
            <b-button v-b-toggle="PopupUid" variant="outline-primary" class="bg-white f-right" v-if="false"
                v-bind:t_label="'EMPBE_VisitorPermission_' + currentRouteName + '_MoreBenefit'">
                <i class="fa fa-unlock-alt"></i>
                <span>{{ $t("lbl_emp2_JoinMemberPageButton") }}</span>
            </b-button>
        </div>
        <b-overlay :show="havePermission" :class="{ IsVisitor: havePermission }" opacity="0.95" z-index="8">
            <slot name="body"></slot>
            <template #overlay>
                <div class="visitorPermissiontext-center">
                    <b-button v-if="!IsHidenBody" class="btSyles_More" v-b-toggle="PopupId ? PopupId : PopupUid"
                        variant="outline-primary" ref="btn_visitorPermissionPopup"
                        v-bind:t_label="'EMPBE_VisitorPermission_' + currentRouteName + '_btnLearnMore'">
                        <img :src="cdnURL + 'eyes.svg'">
                        <span>{{ MoreText ?? $t("lbl_EMPBE_LearnMore") }}</span>
                    </b-button>
                    <b-button class="btSyles_ConBuyer" variant="primary" v-if="CellUrl && !IsHidenBody"
                        @click="GotoCellUrl" v-bind:t_label="'EMPBE_VisitorPermission_' + currentRouteName + '_Url'">
                        <img :src="cdnURL + 'cell.svg'">
                        <span>{{ $t("lbl_EMPBE_visitorPermissionPopup_ConBuyerPhone") }}</span>
                    </b-button>
                </div>
            </template>
        </b-overlay>
        <Divpopup :PopupUid="PopupUid"></Divpopup>
    </div>
</template>

<script>
import Divpopup from './visitorPermissionPopup.vue'
export default {
    props: {
        Permission: {},
        PopupId: String,
        CellUrl: String,
        MoreText: String,
        IsHidenBody: Boolean,
        TitleText: String,
        /** 无广告权限时整项隐藏（默认 true）；设为 false 时显示锁条与联系销售 */
        hideWhenNoPermission: { type: Boolean, default: true },
    },
    components: {
        Divpopup
    },
    data() {
        return {
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/componentsIcon/",
            PopupUid: 'visitorPermissionPopup',
            isHidden: false,
            havePermission: this.refreshPermission(),
        };
    },
    mounted() {
        this.PopupUid = 'visitorPermissionPopup' + this._uid
        this.havePermission = this.refreshPermission()
    },
    watch: {
        Permission() {
            this.havePermission = this.refreshPermission()
        }
    },
    computed: {
        user() {
            return this.$store.state.authentication.user
        },
        IsVisitor() {
            return this.$store.state.authentication.user.memberCode == "NORMAL"
        },
        IsAdmin() {
            return this.$store.state.authentication.user.userType == "ADMIN"
        },
        currentRouteName() {
            if (this.$route.name != undefined) {
                return this.$route.name.replaceAll("/", "")
            }
            return this.$route.name;
        },
        isBlockVisible() {
            if (this.hideWhenNoPermission && this.Permission === false) {
                return false;
            }
            return true;
        },
    },
    methods: {
        GotoCellUrl() {
            window.open(this.CellUrl, '_blank');
        },
        //Add to cart
        addToCart: function (sku, qty) {
            var product = this.getCartProductBySku(sku);
            if (product != undefined) {
                this.$store.dispatch('products/updateCartQuantity', { 'product': product, 'qty': 1 });
            }
            else {
                product = this.getProductBySku(sku);
                product.quantity = qty ? qty : 1;
                this.$store.dispatch('products/addToCart', product);
            }
            this.cart_open();
        },
        cart_open() {
            this.$store.dispatch('products/toggleCart', true);
        },
        refreshPermission() {
            if (this.Permission != undefined) {
                return !this.Permission;
            }
            if (this.IsAdmin) {
                return false;
            }
            return this.IsVisitor;
        }
    }
};
</script>
<style>
.IsVisitor .customizer-formbutton {
    display: none;
}

.visitorPermissiontext-center {
    display: flex;
    gap: 8px;
}
</style>
<style scoped>
.btSyles_More {
    padding: 8px 16px 8px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-flex;
    gap: 8px;
}
.Title_btSyles_ConBuyer
{
        display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 4px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 8px 12px 8px 8px;
    height: 28px;
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    word-wrap: break-word;
    height: 28px;
}
.Title_btSyles_More
{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 4px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 8px 12px 8px 8px;
    height: 28px;
    color: rgba(0, 0, 0, 0.6) !important;
    background: none !important;
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    word-wrap: break-word;
    border-radius: 4px;
    border: 1px rgba(0, 0, 0, 0.4) solid !important;
    height: 28px;
}
  .Title_btSyles_More:hover
  {
    background:linear-gradient(180deg,#fff 0%,#faf7ff 100%) !important;
  }

.btSyles_ConBuyer {
    padding: 8px 16px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-flex;
    gap: 8px;
}

.TitleBg {
    background: rgba(0, 0, 0, 0.03) !important;
    border-color: rgba(0, 0, 0, 0.03) !important;
    padding:16px 24px !important;
    border-radius: 999px !important;
}

.TitleBg_Title {
    color: rgba(0, 0, 0, 0.80);
    font-size: 14px;
    font-weight: 600;
    line-height: 14px;
    word-wrap: break-word;
    display: flex;
    align-items: center;
    gap: 8px;
}
.TitleBgFlex{
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.TitleBg_Btn
{
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>